import React, { useState, useRef, useEffect } from 'react';
import { BaseModal } from './Modals.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faImages, faImage } from '@fortawesome/free-solid-svg-icons';

export default function EvidenceModal({ files, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageError, setImageError] = useState(false);
  const videoRef = useRef(null);

  const currentFile = files?.[currentIndex];
  const isVideo = currentFile?.mime_type?.startsWith('video/');

  // Forzar la carga del video cuando cambia el archivo actual
  useEffect(() => {
    if (videoRef.current && isVideo) {
      videoRef.current.load();
    }
    // Reset error state when changing files
    setImageError(false);
  }, [currentIndex, isVideo]);

  if (!files || files.length === 0) {
    return null;
  }

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? files.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === files.length - 1 ? 0 : prev + 1));
  };

  return (
    <BaseModal title="Evidencias" size="xl" onClose={onClose}>
      <BaseModal.Body>
        <div className="position-relative" style={{ minHeight: '400px' }}>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
            {isVideo ? (
              <video
                ref={videoRef}
                key={currentFile.url}
                src={currentFile.url}
                controls
                preload="auto"
                style={{ maxWidth: '100%', maxHeight: '500px' }}
                className="rounded"
              >
                Tu navegador no soporta el elemento de video.
              </video>
            ) : imageError ? (
              <div className="text-center">
                <FontAwesomeIcon icon={faImage} size="5x" className="text-muted" />
                <div className="mt-3 text-muted">Imagen</div>
                <div className="mt-2 text-danger">Error al cargar evidencia</div>
              </div>
            ) : (
              <img
                src={currentFile.url}
                alt={`Evidencia ${currentIndex + 1}`}
                style={{ maxWidth: '100%', maxHeight: '500px', objectFit: 'contain' }}
                className="rounded"
                onError={() => {
                  console.error('Error loading image:', currentFile.url);
                  setImageError(true);
                }}
              />
            )}
          </div>

          {files.length > 1 && (
            <>
              <button
                className="btn btn-dark position-absolute"
                style={{
                  left: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  opacity: 0.7,
                  zIndex: 10
                }}
                onClick={handlePrevious}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>

              <button
                className="btn btn-dark position-absolute"
                style={{
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  opacity: 0.7,
                  zIndex: 10
                }}
                onClick={handleNext}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </>
          )}
        </div>

        {files.length > 1 && (
          <div className="text-center mt-3">
            <small className="text-muted">
              {currentIndex + 1} de {files.length} - {isVideo ? 'Video' : 'Imagen'}
            </small>
          </div>
        )}

        {files.length > 1 && (
          <div className="d-flex justify-content-center mt-3 flex-wrap">
            {files.map((file, index) => {
              const isThumbVideo = file.mime_type?.startsWith('video/');
              return (
                <button
                  key={index}
                  className={`btn btn-sm m-1 ${index === currentIndex ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setCurrentIndex(index)}
                  style={{ minWidth: '40px' }}
                >
                  {isThumbVideo ? '▶' : '📷'} {index + 1}
                </button>
              );
            })}
          </div>
        )}
      </BaseModal.Body>

      <BaseModal.Footer>
        <button className="btn btn-secondary" onClick={onClose}>
          Cerrar
        </button>
      </BaseModal.Footer>
    </BaseModal>
  );
}
